import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { parse } from 'date-fns';
import { cloneDeep } from 'lodash';

import { useGetProjectQuery, useGetProjectLazyQuery } from '../../../../../../graphql/generated/graphql';
import { CompanyManager } from '../../../../../config/interfaces';

import ConfigProjectLayout from '../../../../../theme/templates/project/config';
import Loading from '../../../../components/loading';
import ViewProjectPage from '../view';
import { UserRoles } from '../../../../../config/enums';
import { Box, CircularProgress } from '@mui/material';

const EditProjectPage = () => {
  const params = useParams();
  let lineProducer: CompanyManager | null | undefined = null;
  const productionCoordinator: CompanyManager[] = [];
  const officePa: CompanyManager[] = [];
  let tempProjectCompanyManagers: any[] = [];
  const { data: infoProject, loading, refetch } = useGetProjectQuery({
    variables: {
      project_id: params.projectId as string,
    },
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    if (refetch) {
      refetch({
        project_id: params.projectId as string,
      })
    }
  }, []);

  if (loading && !params.projectId) {
    return <Loading />;
  }

  if (loading && params.projectId) {
    return <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
    }}
    >
      <CircularProgress />
    </Box>
  }

  if (infoProject) {
    infoProject.getProject?.project_managers?.forEach((element: any) => {
      if (element.user_role === UserRoles.LINE_PRODUCER) {
        lineProducer = element;
      } else if (element.user_role === UserRoles.PRODUCTION_COORDINATOR) {
        productionCoordinator.push(element);
      } else if (element.user_role === UserRoles.OFFICE_PA) {
        officePa.push(element);
      }
    });

    const tempCompanyManager = cloneDeep(infoProject.getProject?.company_managers || [])
    if (infoProject.getProject?.company_managers) {
      tempProjectCompanyManagers = cloneDeep(infoProject.getProject?.company?.company_managers || [])
      tempCompanyManager.forEach((element: any) => {
        const selectedIndex = tempProjectCompanyManagers.findIndex((x: any) => x.id === element.user_id);
        if (selectedIndex >= 0) {
          tempProjectCompanyManagers[selectedIndex].checked = true;
        }
      });
    }
  }

  return (
    <>
      {!params.projectId &&
        <ConfigProjectLayout>
          <ViewProjectPage
            company={infoProject?.getProject?.company}
            projectId={params.projectId}
            urlLogo={infoProject?.getProject?.client_logo_url}
            projectName={infoProject?.getProject?.project_name}
            numProject={infoProject?.getProject?.num_project}
            startDate={parse(infoProject?.getProject?.start_date as string, 'yyyy-MM-dd', new Date())}
            endDate={parse(infoProject?.getProject?.end_date as string, 'yyyy-MM-dd', new Date())}
            companyManagers={tempProjectCompanyManagers}
            lineProducer={lineProducer}
            productionCoordinator={productionCoordinator}
            officePa={officePa}
            edit
          />
        </ConfigProjectLayout>
      }
      {params.projectId &&
        <>
          <ViewProjectPage
            company={infoProject?.getProject?.company}
            projectId={params.projectId}
            urlLogo={infoProject?.getProject?.client_logo_url}
            projectName={infoProject?.getProject?.project_name}
            numProject={infoProject?.getProject?.num_project}
            startDate={parse(infoProject?.getProject?.start_date as string, 'yyyy-MM-dd', new Date())}
            endDate={parse(infoProject?.getProject?.end_date as string, 'yyyy-MM-dd', new Date())}
            companyManagers={tempProjectCompanyManagers}
            lineProducer={lineProducer}
            productionCoordinator={productionCoordinator}
            officePa={officePa}
            edit
          />
        </>
      }
    </>
  );
}

export default EditProjectPage;
